import { FIVE_AXIS, TRIVIAL } from '../../constants/machine-state/kinematics-mode';
import actions from '../../actions';
import { handleActions } from 'redux-actions';

const reducer = handleActions(
  {
    [actions.machineState.kinematicsMode.setFiveAxis]: () => FIVE_AXIS,
    [actions.machineState.kinematicsMode.setTrivial]: () => TRIVIAL,
    [actions.interpreter.stop]: () => TRIVIAL,
    [actions.interpreter.run]: () => TRIVIAL
  },
  TRIVIAL
);

export default reducer;
